module.exports = __webpack_public_path__ + "img/iso_9001.74047956.jpg";